<template>
  <section class="admin-content" id="contact-search">
    <!-- <Navbar/> -->
    <main class="admin-main">
      <section class="">
        <div class="">
          <div class="row list">
            <div class="col-lg-12 col-md-12">
              <div class="card m-b-30">
                <div class="card-body">
                  <div class="text-center">
                    <h1 class="h3">
                      <strong>Informal Enrollee Biodata Form</strong>
                    </h1>
                    <p>
                      (All fields marked with
                      <span class="text-danger">*</span> are compulsory)
                    </p>
                  </div>
                  <form @submit.prevent="submitForm">
                    <div class="form-row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="inputCity">Select Sector
                            <span class="text-danger">*</span></label>
                          <select class="form-control" v-model="sector" disabled>
                            <option value="Formal">Formal Sector</option>
                            <option value="Informal">Informal Sector</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="inputCity">Select Sub-Informal Sector
                          </label>
                          <select class="form-control" required v-model="register.sector">
                            <option :value="sector" v-for="sector in sectors" :key="sector">
                              {{ sector }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <div class="form-group col-md-6" v-if="
                          register.sector == 'Basic Healthcare Provision Fund' ||
                          register.sector == 'UNICEF'
                        ">
                        <label>Select Vulnerable Group</label>
                        <select class="form-control" required v-model="register.category_of_vulnerable_group">
                          <option :value="vul" v-for="vul in bhcpf_vulnerables" :key="vul">
                            {{ vul }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6" v-if="register.sector == 'GAVI'">
                        <label>Select Vulnerable Group</label>
                        <select class="form-control" required v-model="register.category_of_vulnerable_group">
                          <option :value="vul" v-for="vul in gavi_vulnerables" :key="vul">
                            {{ vul }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6" v-if="
                          register.category_of_vulnerable_group ==
                          'People with Disabilities'
                        ">
                        <label>Type of Disability</label>
                        <select class="form-control" v-model="register.special_need">
                          <option value="Blind">Blind</option>
                          <option value="Deaf">Deaf</option>
                          <option value="Physical Disability">
                            Physical Disability
                          </option>
                          <option value="Mentally Ill">Mentally Ill</option>
                          <option value="Dumb">Dumb</option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label>Means of Identification
                          <span class="text-danger">*</span></label>
                        <select disabled class="form-control" v-model="register.means_of_id">
                          <option value="NIN Number">NIN Number</option>
                          <!-- <option value="Voter's Card">Voter's Card</option>
                          <option value="Driver's License">
                            Driver's License
                          </option>
                          <option value="International Passport">
                            International Passport
                          </option> -->
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputEmail4">NIN <span class="text-danger">*</span>

                        </label>
                        <input type="text" pattern="\d*" maxlength="11" required class="form-control"
                          v-model="register.nimc_number" placeholder="ID Number" />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputPassword4">Surname <span class="text-danger">*</span></label>
                        <input type="text" required class="form-control" v-model="register.lastname"
                          placeholder="Last Name" />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputEmail4">First Name <span class="text-danger">*</span></label>
                        <input type="text" required class="form-control" v-model="register.firstname"
                          placeholder="First Name" />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputPassword4">Middle Name</label>
                        <input type="text" class="form-control" v-model="register.middlename" placeholder="Last Name" />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputPassword4">Date of Birth
                          <span class="text-danger">*</span></label>

                        <input required type="date" class="form-control" v-model="register.dob"
                          placeholder="12/12/1900" />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputPassword4">Phone Number<span class="text-danger">*</span></label>
                        <input v-phone type="text" pattern="\d*" class="form-control"
                          v-model="register.phone_number" placeholder="Phone Number" />
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="inputCity">Gender <span class="text-danger">*</span></label>
                        <select class="form-control" v-model="register.gender" required>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label>Marital Status <span class="text-danger">*</span></label>
                        <select class="form-control" required v-model="register.marital_status">
                          <option value="Married">Married</option>
                          <option value="Widow">Widow</option>
                          <option value="Single">Single</option>
                          <option value="Separated">Separated</option>
                          <option value="Divorced">Divorced</option>
                        </select>
                      </div>

                      <!-- <div class="form-group col-md-6">
                        <label for="inputCity">State of Origin </label>

                        <select
                          class="form-control"
                          v-model="register.state_of_origin"
                          @change="fetchLgaOrigin()"
                        >
                          <option
                            v-for="state in states"
                            v-bind:key="state.id"
                            :value="state.id"
                            >{{ state.name }}</option
                          >
                        </select>
                      </div> -->
                      <!-- <div class="form-group col-md-6">
                        <label for="inputCity">LGA of Origin</label>
                        <select
                          class="form-control"
                          v-model="register.lga_of_origin"
                        >
                          <option
                            v-for="lga in lga_states_origin"
                            v-bind:key="lga"
                            :value="lga.local_name"
                            >{{ lga.local_name }}</option
                          >
                        </select>
                      </div> -->

                      <div class="form-group col-md-6">
                        <label for="inputCity">Local Government Area<span class="text-danger">*</span></label>
                        <select class="form-control" required v-model="register.localgovt" @change="fetchWards">
                          <option v-for="lga in lga_states" v-bind:key="lga" :value="lga">
                            {{ lga.local_name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label>Ward<span class="text-danger">*</span></label>
                        <select class="form-control" required v-model="register.ward"
                          @change="getProvidersByWards($event)">
                          <option v-for="ward in wards" v-bind:key="ward.id" :value="ward.id">
                            {{ ward.ward_name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputCity">Facility to Access Care <span class="text-danger">*</span></label>
                        <select class="form-control" required v-model="register.provider_id">
                          <option v-for="provider in providers" :key="provider.id" :value="provider.id">
                            {{ provider.agency_name }}
                          </option>
                        </select>
                      </div>

                      <!-- <div class="col-md-12 row">
                        <div class="form-group col-md-6">
                          <label
                            >Principal Facility for Accessing Health Care
                            <span class="text-danger">*</span></label
                          >
                          <v-select
                            v-model="register.provider_id"
                            :options="providers"
                            required
                            label="agency_name"
                            :value="register.provider_id"
                            @input="selected"
                          ></v-select>
                        </div>
                        
                        <div class="form-group col-md-6">
                          <label>
                            Alternate Facility for Accessing Health Care
                            <span class="text-danger">*</span></label
                          >
                          <v-select
                            v-model="register.point_of_care"
                            required
                            :options="providers"
                            label="agency_name"
                            :value="register.point_of_care"
                            @input="selectedPointocare"
                          ></v-select>
                        </div>                      
                      </div> -->

                      <div class="form-group col-md-6">
                        <label for="inputAddress">Home Address <span class="text-danger">*</span> </label>
                        <input type="text" class="form-control" required v-model="register.address"
                          placeholder="1234 Main St" />
                      </div>
                    </div>

                    <div class="form-group col-md-12">
                      <button class="btn btn-outline-info" type="button" @click="takePicAndroid">
                        Capture Photo <i class="fe fe-camera"></i>
                        <span v-if="!photoRequired" class="text-muted ml-1">(Optional)</span>
                      </button>
                    </div>

                    <div class="form-group col-md-6" v-if="register.user_image">
                      <img :src="register.user_image" class="rounded img-fluid" alt="Enrollee Photo"
                        onerror="this.onerror=null; this.src='/assets/img/placeholder.svg'" />
                      <div class="mt-2" v-if="register.user_image && photoOriginal">
                        <button class="btn btn-outline-secondary btn-sm" type="button" @click="cropPhoto(photoOriginal)">
                          <i class="fe fe-crop mr-1"></i> Adjust
                        </button>
                      </div>
                    </div>

                    <div class="form-group" v-if="
                        register.provider_id != null &&
                        register.point_of_care != null
                      ">
                      <button class="btn btn-info btn-block" type="submit">
                        Submit <i class="fe fe-send"></i>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div class="vld-parent">
              <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
            </div>
            <PhotoCropper ref="photoCropper" />
          </div>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
  import PhotoCropper from "@/components/PhotoCropper.vue";

  export default {
    components: { PhotoCropper,
      Loading,
    },
    data() {
      return {
        photoOriginal: "",
        isLoading: false,
        fullPage: true,
        sectors: [
          "Basic Healthcare Provision Fund",
          "State Equity Program",
          "Voluntary Contributor",
          "Vital Contributor",
          "Pro Health International",
          "UNICEF",
          "GAVI",
          "NURTW",
          "KEKE RIDERS",
          "OKADA RIDERS",
          "FARMERS ASSOCIATION",
          "MARKET WOMEN ASSOCIATION",
          "ZAKKAT & ENDOWMENT BOARD",
          "ALGON",
        ],
        bhcpf_vulnerables: [
          "Aged",
          "Children Under 5",
          "People with special needs",
          "Pregnant Woman",
          "FFP",
          "CEmONC",
          "Woman of Child bearing Age",
        ],

        gavi_vulnerables: [
          "Children under 5",
          "Pregnant Women",
          "Women of Child Bearing Age",
        ],
        states: "",
        show: false,
        clients: "",
        providers: "",
        sector: "Informal",
        mdas: [],
        wards: "",
        providers_wards: "",
        state: "",
        OfficerDetails: "",
        current_page: "",
        selected_provider: "",
        selected_provider_dependents: "",
        lga_states: "",
        lga_states_origin: "",
        register: {
          firstname: "",
          lastname: "",
          middlename: "",
          nimc_number: "",
          means_of_id: "NIN Number",
          state_of_origin: "",
          lga_of_origin: "",
          email: "",
          phone_number: "",
          type: "client",
          agency_id: "",
          state: "",
          localgovt: "",
          ward: "",
          address: "",
          blood: "",
          weight: "",
          special_need: "",
          gender: "",
          genotype: "",
          dob: "",
          salary_number: "",
          provider_id: "",
          point_of_care: "",
          sector: "",
          finger_print: "",
          place_of_work: "",
          grade_level: "",
          date_of_entry: "",
          marital_status: "",
          category_of_vulnerable_group: "",
          user_image: "",
        },
      };
    },
    computed: {
      // A photo is required for every sub-sector except Voluntary Contributor (as in claimify).
      photoRequired() {
        return this.register.sector !== "Voluntary Contributor";
      },
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
    },
    methods: {
      selected(value) {
        this.selected_provider = value.id;
      },
      selectedPointocare(value) {
        this.selected_provider_dependents = value.agency_name;
      },
      // this.selected_provider || this.register.provider_id == '' && this.selected_provider_dependents|| this.register.point_of_care == '' &&
      submitForm() {
        if (this.photoRequired && !this.register.user_image) {
          this.$toasted.error("Capture the enrollee's photo before submitting", {
            position: "top-center",
            duration: 3000,
          });
          return;
        }
        if (this.user.type == "employee") {
          // console.log('employee');
          this.registerUserEmployee();
        }
        if (this.user.type == "tpa_employee") {
          // console.log('tpa_employee');
          this.registerUserTPA();
        }
        if (this.user.type == "shis") {
          // console.log('1');
          this.registerUserAdmin();
        }
      },
      fetchWards() {
        this.axios
          .get(`/api/v1/auth/getwards/${this.register.localgovt.id}`)
          .then((response) => {
            this.wards = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      fetchLga() {
        this.axios
          .get(`/api/v1/auth/lga/2683`)
          .then((response) => {
            this.lga_states = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      fetchLgaOrigin() {
        this.axios
          .get(`/api/v1/auth/lga/${this.register.state_of_origin}`)
          .then((response) => {
            this.lga_states_origin = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getMDAs() {
        this.axios
          .get(`/api/v1/auth/ministries/4`)
          .then((response) => {
            this.mdas = response.data.data;
            console.log(response.data);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      registerUserAdmin() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.isLoading = true;
        this.axios
          .post("/api/v1/auth/registerProvider", {
            nimc_number: this.register.nimc_number,
            firstname: this.register.firstname.toUpperCase(),
            lastname: this.register.lastname.toUpperCase(),
            middlename: this.register.middlename.toUpperCase(),
            email: this.register.email,
            phone_number: this.register.phone_number,
            type: this.register.type,
            sectorType: this.sector,
            sector: this.register.sector,
            agency_id: 4,
            provider_id: this.register.provider_id,
            point_of_care: this.register.point_of_care,
            state: "2683",
            special_need: this.register.special_need,
            role: 0,
            password: "euhler",
            localgovt: this.register.localgovt.id,
            ward: this.register.ward,
            blood: this.register.blood,
            dob: this.register.dob,
            address1: this.register.address,
            genotype: this.register.genotype,
            weight: this.register.weight,
            gender: this.register.gender,
            place_of_work: this.register.place_of_work,
            finger_print: this.register.finger_print,
            salary_number: this.register.salary_number,
            grade_level: this.register.grade_level,
            date_of_entry: this.register.date_of_entry,
            marital_status: this.register.marital_status,
            category_of_vulnerable_group:
              this.register.category_of_vulnerable_group,
            user_image: this.register.user_image,
            enrolled_by: this.user.id,
          })
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            this.$toasted.info("Client added Successfully", {
              position: "top-center",
              duration: 3000,
            });
            let user_id = response.data.data.id;

            this.$router.push(`/client/${user_id}`);
          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;
            this.showSubmitError(error);
          });
      },

      registerUserEmployee() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.isLoading = true;
        this.axios
          .post("/api/v1/auth/registerProvider", {
            agency_id: this.user.institutional_id,
            nimc_number: this.register.nimc_number,
            firstname: this.register.firstname.toUpperCase(),
            lastname: this.register.lastname.toUpperCase(),
            middlename: this.register.middlename.toUpperCase(),
            email: this.register.email,
            phone_number: this.register.phone_number,
            type: this.register.type,
            sectorType: this.sector,
            sector: this.register.sector,
            special_need: this.register.special_need,
            provider_id: this.selected_provider
              ? this.selected_provider
              : this.register.provider_id,
            point_of_care: this.selected_provider_dependents
              ? this.selected_provider_dependents
              : this.register.point_of_care,
            state: "2683",
            role: 0,
            password: "jacobi",
            localgovt: this.register.localgovt.id,
            ward: this.register.ward,
            blood: this.register.blood,
            dob: this.register.dob,
            address1: this.register.address,
            genotype: this.register.genotype,
            means_of_id: this.register.means_of_id,
            state_of_origin: this.register.state_of_origin,
            lga_of_origin: this.register.lga_of_origin,
            gender: this.register.gender,
            place_of_work: this.register.place_of_work,
            finger_print: this.register.finger_print,
            salary_number: this.register.salary_number,
            grade_level: this.register.grade_level,
            date_of_entry: this.register.date_of_entry,
            marital_status: this.register.marital_status,
            category_of_vulnerable_group:
              this.register.category_of_vulnerable_group,
            user_image: this.register.user_image,
            enrolled_by: this.user.id,
          })
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            // this.getClients();
            this.$toasted.info("Client added Successfully", {
              position: "top-center",
              duration: 3000,
            });
            let user_id = response.data.data.id;
            this.$router.push(`/client/${user_id}`);
          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;
            this.showSubmitError(error);
          });
      },
      showSubmitError(error) {
        const data = error.response && error.response.data;
        let message;
        if (data && data.errors) {
          this.response = data.errors;
          message = Object.values(data.errors).flat().join(" ");
        } else if (data && data.message) {
          message = data.message;
        } else {
          message =
            "Could not reach the server. If you attached a photo, try again, then check your connection and submit again.";
        }
        this.$toasted.error(message, {
          position: "top-center",
          duration: 6000,
        });
      },
      // Photos are resized to at most 1024px and re-encoded as JPEG so the upload stays small
      // (large camera images were rejected with 413 in production).
      // Opens the cropper; keeps the uncropped photo so it can be adjusted again.
      async cropPhoto(src) {
        const cropped = await this.$refs.photoCropper.open(src);
        if (!cropped) return false;
        this.photoOriginal = src;
        this.register.user_image = cropped;
        return true;
      },
      async takePicAndroid() {
        try {
          const image = await Camera.getPhoto({
            quality: 70,
            allowEditing: false,
            resultType: CameraResultType.Base64,
            source: CameraSource.Camera,
          });
          if (!(await this.cropPhoto("data:image/jpeg;base64," + image.base64String))) return;
          this.$toasted.info("Photo captured successfully!", {
            position: "top-center",
            duration: 3000,
          });
        } catch (err) {
          if (err && err.message !== "User cancelled photos app") {
            this.$toasted.error("Could not access camera.", {
              position: "top-center",
              duration: 3000,
            });
          }
        }
      },
      getProviders() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/providerAgency/4`)
          .then((response) => {
            this.providers = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getStates() {
        this.axios
          .get(`/api/v1/auth/states`)
          .then((response) => {
            this.states = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      getProvidersByWards() {
        if (this.register.sector == "Basic Healthcare Provision Fund" || this.register.sector == "UNICEF") {
          this.axios
            .get(
              `/api/v1/auth/providerAgencies/4/${this.register.localgovt.id}/${this.register.ward}`
            )
            .then((response) => {
              this.providers = response.data.data;
              console.log(response);
            })
            .catch((error) => {
              console.error(error);
            });
        } else {
          console.log("dont change anything");
        }
      },
    },
    created() {
      this.fetchLga();
      this.getStates();
      this.getMDAs();
      this.getProviders();
      this.getOfficerDetails();
    },
  };
</script>